import { useContextSelector } from "use-context-selector";
import { GlobalContext } from "../lib/internals";
/**
 *
 * @param callback
 */
export function useGlobalContext(callback) {
    return useContextSelector(GlobalContext, function (state) {
        if (state === undefined) {
            throw new Error("Make sure function is used in the <GlobalContext.Provider />");
        }
        return callback(state);
    });
}
